import IndexModel from "@/service/v1/sigap/IndexModel";

class QtsSemanalService extends IndexModel {

    constructor() {
        super();
        this.url = this.url + '/QtsSemanal';
    }

    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    // URL do PDF do QTS (F3). O token vai na query string (mesmo padrão dos demais relatórios).
    public getPdfUrl(id: any, token: any): string {
        return `${this.getApiUrl()}/${id}/Pdf?token=${token}`;
    }

    // URL do PDF da relação de alocações por horário (DATA × DIA × HORÁRIO, com pelotão).
    public getPdfPorHorarioUrl(id: any, token: any): string {
        return `${this.getApiUrl()}/${id}/PdfPorHorario?token=${token}`;
    }

    // PDF (uma página por pelotão) como blob, para exibição em tela (iframe via object URL).
    public getPdfBlob(id: any): Promise<Blob> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(`${this.url}/${id}/Pdf`, { responseType: 'blob' })
                .then(response => resolve(response.data))
                .catch(error => reject(error.response));
        });
    }

    // PDF da relação por horário como blob, para exibição em tela.
    public getPdfPorHorarioBlob(id: any): Promise<Blob> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(`${this.url}/${id}/PdfPorHorario`, { responseType: 'blob' })
                .then(response => resolve(response.data))
                .catch(error => reject(error.response));
        });
    }

    public getModel(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // Duplica o QTS para um novo período, copiando o cabeçalho e apenas as disciplinas (com restrições).
    public duplicar(id: any, dados: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/Duplicar`, dados)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // Dispara a geração do QTS para esta configuração (Épico E).
    // Retorna o GeracaoResultado (sucesso + alocações, ou diagnóstico de inviabilidade).
    public gerar(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/Gerar`, {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // F1 — revalida as hard rules e move o QTS de GERADO para VALIDADO.
    // Retorna QtsValidacaoResultadoDTO { ok, mensagem, violacoes[] }.
    public validar(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/Validar`, {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // F1 — publica (congela) o QTS: VALIDADO → PUBLICADO.
    public publicar(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/Publicar`, {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // F1 — cancela o QTS (qualquer status, exceto PUBLICADO).
    public cancelar(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().post(`${this.url}/${id}/Cancelar`, {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // Apaga todas as alocações do QTS (exceto se PUBLICADO). Retorna { removidas }.
    public limparAlocacoes(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().delete(`${this.url}/${id}/alocacoes`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // F2 — QTS montado como grade (dia × horário × pelotão) para visualização.
    public grade(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(`${this.url}/${id}/Grade`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    // RN09 — capacidade (horas-aula disponíveis por pelotão) cruzando dias × quadro de horário.
    public capacidade(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(`${this.url}/${id}/Capacidade`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    public getStatus(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(`${this.url}/GetStatus`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

}

export default QtsSemanalService;
